"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// import the build index.css
require("./index.css");
// export our default example component
var JsonToTable_1 = require("./JsonToTable");
exports.JsonToTable = JsonToTable_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-json-to-table/build/lib/components/index.js
// module id = 399
// module chunks = 0